<template>
  <div class="item">
    <div class="label"
         :class="{ focus: isFocused || value !== '', error: isError }">
      <p>
        {{ title }}
      </p>
    </div>
    <input ref="input" :type="type"
           :name="keyIndex"
           :value="value"
           :class="{ error: isError, 'error-border': isError }"
           @input="updateValue($event.target.value)"
           @focus="activeFocus"
           @blur="noneFocus"
           @keyup.enter="callback"/>
  </div>
</template>

<script>
import InputLayout from './LayoutInput';

export default {
  name: 'LayoutStyledInput',
  mixins: [InputLayout],
  props: {
    title: {
      type: String,
    },
    callback: {
      type: Function,
      default: () => {},
    },
    isInitFocus: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    activeFocus() {
      this.isFocused = true;
    },

    noneFocus() {
      this.isFocused = false;
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
  mounted() {
    if (this.isInitFocus) {
      this.$nextTick(() => this.$refs.input.focus());
    }
  },
};
</script>

<style lang="scss" scoped>

.item {
  width: 100%;
  height: 80px;
  position: relative;

  .label {
    position: absolute;
    z-index: 2;
    font-size: 16px;
    color: #bbbbbb;
    transform: translateY(14px);
    transition: all 0.3s;

    &.focus {
      font-weight: 700;
      font-size: 12px;
      transform: translateY(-14px);
      color: #3d9cff;
    }
  }

  .error {
    color: rgb(222, 85, 80) !important;
  }

  .error-border {
    border-bottom: 1px solid rgb(222, 85, 80) !important;
  }

  input {
    position: relative;
    z-index: 3;

    width: 100%;
    height: 48px;

    background-color: transparent;
    border: none;
    border-bottom: 1px solid #ececec;
    transition: all 0.3s;

    &:focus {
      outline: none;
      border-bottom: 1px solid #3d9cff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutStyledInput.vue